var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArraoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53033 3.71967C9.23744 3.42678 8.76256 3.42678 8.46967 3.71967C8.17678 4.01256 8.17678 4.48744 8.46967 4.78033L12.4393 8.75H3.75C3.33579 8.75 3 9.08579 3 9.5C3 9.91421 3.33579 10.25 3.75 10.25H12.4393L8.46967 14.2197C8.17678 14.5126 8.17678 14.9874 8.46967 15.2803C8.76256 15.5732 9.23744 15.5732 9.53033 15.2803L14.7803 10.0303C15.0732 9.73744 15.0732 9.26256 14.7803 8.96967L9.53033 3.71967Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArraoRight);
export default __webpack_public_path__ + "static/media/arrao-right.9320685418a83c9bc943c3f2bdc2e76a.svg";
export { ForwardRef as ReactComponent };